<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>

		<main-content>
			<template #content>
				<div class="columns column6">
					<h1>{{ page.title || page.header }}</h1>
					<div v-parse-links v-html="page.content" />
					<book-button v-if="page.bookingID" :roomid="page.bookingID" class="button">
						{{ $t('bookThisRoom') }}
					</book-button>
				</div>
			</template>
			<template #right-content>
				<div v-parse-links class="columns column6" v-html="page.rightContent" />
			</template>
		</main-content>

		<div class="main-content" :class="page.gallery.length ? 'gallery-section' : 'button-section'">
			<div class="row">
				<div v-for="(item, index) in page.gallery" :key="index" class="columns column6">
					<a
						v-if="item.images.length"
						:data-src="item.images[0]"
						class="gallery-item"
						data-fancybox="gallery"
						:data-caption="item.imageAlt"
						rel="Gallery"
						:title="item.imageAlt"
					>
						<picture>
							<source :srcset="item.imagesWebp[1]" type="image/webp" />
							<source :srcset="item.images[1]" />
							<img :src="item.images[1]" :alt="item.imageAlt" loading="lazy" />
						</picture>
					</a>
				</div>
			</div>
			<div class="row">
				<div class="columns column12">
					<button-container>
						<nuxt-link
							:to="localePath('meetingrooms')"
							class="button button-no-fill"
							style="margin: 0 auto"
						>
							{{ defaults[locale].rooms.more }}
						</nuxt-link>
					</button-container>
				</div>
			</div>
		</div>

		<contentblocks
			v-if="page.contentblocks && page.contentblocks.length"
			:contentblocks="page.contentblocks"
			:contentblocks-content="page.contentBlockContent"
		/>

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer v-if="page.footerSection && page.footerSection.length" :footer-section="page.footerSection[0]" />
		<newsletter
			v-if="page.showNewsletter"
			:header="defaults[locale].newsletterForm.title"
			:content="defaults[locale].newsletterForm.content"
			:email="defaults[locale].newsletterForm.email"
			:button="defaults[locale].newsletterForm.button"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();
const localePath = useLocalePath();

await fetchPage();
await fetchDefaults();
</script>

<style lang="scss" scoped>
.gallery-section {
	.column6 {
		padding: 15px 30px;
	}
}

@media (max-width: 960px) {
	.gallery-section {
		padding-top: 0;
	}
}
</style>
